/**
 * Registered Company Line-2 peers (same SubPageNav style as buildings).
 * Overview · Our Partner · Partly agent · Agent · Registered IQP · Engineers
 */

export const NETWORK_PEER_IDS = [
  'overview',
  'our-partner',
  'partly-agent',
  'agent',
  'iqp',
  'engineers',
];

const SECTION_TABS = new Set(['our-partner', 'partly-agent', 'agent', 'iqp', 'engineers']);

export function getNetworkPeerNav(pathname, search = '') {
  const peers = [
    { id: 'overview', label: 'Overview', to: '/network' },
    { id: 'our-partner', label: 'Our Partner', to: '/network?tab=our-partner' },
    { id: 'partly-agent', label: 'Partly agent', to: '/network?tab=partly-agent' },
    { id: 'agent', label: 'Agent', to: '/network?tab=agent' },
    { id: 'iqp', label: 'Registered IQP', to: '/network?tab=iqp' },
    { id: 'engineers', label: 'Engineers', to: '/network?tab=engineers' },
  ];
  const activeId = detectNetworkPeer(pathname, search);
  return peers.map((p) => ({ label: p.label, to: p.to, active: p.id === activeId }));
}

function detectNetworkPeer(pathname, search = '') {
  const p = pathname || '';
  if (p.startsWith('/network/partners')) return 'our-partner';
  if (p.startsWith('/network/org')) return 'agent';
  if (p.startsWith('/experts')) return 'engineers';

  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search || '');
  const tab = params.get('tab');
  if (tab && SECTION_TABS.has(tab)) return tab;
  return 'overview';
}

export function resolveNetworkNav({ pathname, search = '' }) {
  const onHub = pathname === '/network';
  return {
    trail: onHub ? [] : [{ label: 'Registered Company', to: '/network' }],
    subPages: getNetworkPeerNav(pathname, search),
  };
}
